import { useMemo } from 'react';

import { PERMISSIONS, usePlatformAuthorization } from '@/lib/auth';

export const useBroadcastersPermissions = () => {
  const { hasPlatformPermission } = usePlatformAuthorization();

  const { canCreate, canUpdate, canDuplicate, canDelete } = useMemo(
    () => ({
      canCreate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_CHANNEL]),
      canUpdate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_CHANNEL]),
      canDuplicate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_CHANNEL]),
      canDelete: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.DELETE_CHANNEL]),
    }),
    [hasPlatformPermission]
  );

  return {
    canCreate,
    canUpdate,
    canDuplicate,
    canDelete,
  };
};
